<template>
  <div>
    <el-input disabled :placeholder="placeholder?placeholder:'请点击按钮生成链接'" class="w400" v-model="inputValue">
      <template #append>
        <el-button @click="openDialog" size="small" type="primary">链接生成</el-button>
      </template>
    </el-input>
    <el-dialog title="链接生成" v-model="visible" :width="width"  v-if="visible" append-to-body>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="搜索" name="2">
          <div class="tl pl20 pt20 pb20">
            搜索条件:<el-input  placeholder="请输入搜索条件" class="w500 ml20" v-model="searchValue"></el-input>
          </div>
        </el-tab-pane>
<!--        <el-tab-pane label="分类" name="3">
          <div class="tl pl20 pt10">
            <div class="mb30">商品分类:<el-tag v-show="classify&&classify.label" class="ml20" type="danger">{{classify3.label?classify3.label:(classify2.label?classify2.label:classify.label)}}</el-tag></div>
            <el-tabs  @tab-click="selectClassify" tab-position="left" style="height: 300px;">
              <el-tab-pane :key="item.value" :name="item.value"  v-for="item in optionList" :label="item.label">
                <span class="ml10 classify_span cp"
                      :class="[{'active':classify2.label==child.label}]"
                      @click="selectClassifyItem(child)"
                      :key="child.value" v-for="child in item.children">
                  {{child.label}}
                </span>
                <br/>
                <span class="ml10 classify_span cp"
                      v-for="child in classify2.children"
                      :class="[{'active':classify3.label==child.label}]" @click="selectClassifyItem2(child)"  :key="child.value">
                    {{child.label}}
                </span>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-tab-pane>-->
        <el-tab-pane label="商品" name="4">
          <div class="tl pt20 pb20">
              <t-button @click="$refs.goodsClick.open(0)">商城商品</t-button>
              <t-button @click="$refs.goodsClick.open(1)">租售商品</t-button>
              <goods-click-all ref="goodsClick" @change="changeGoods"></goods-click-all>
          </div>
          <el-tag v-if="goodsName" closable @close="removeGoods">{{goodsName}}</el-tag>
        </el-tab-pane>
        <el-tab-pane label="自定义" name="1">
          <div class="tl pl20 pt20 pb20">
            链接地址:<el-input  placeholder="请输入链接地址" class="w500 ml20" v-model="diyUrl"></el-input>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible=false">取 消</el-button>
        <el-button type="primary" @click="save()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import TButton from "@/components/el/t-button.vue";
  import GoodsClickAll from "@view/components/goods/goods-click-all.vue";

  export default {
    name: "input-url",
    components: {GoodsClickAll, TButton},
    props:['modelValue','placeholder'],
    data() {
      return {
        loading: false,
        inputValue:'',
        visible:false,
        activeName:'2',
        diyUrl:'',
        searchValue:'',
        width:'40%',
        classify:{},
        optionList:[],
        goodsId:"",
        classify2:{},
        classify3:{},
        goodsName:"",
        goodsType:"",
      }
    },
    watch: {
      modelValue: function (newValue) {
        this.inputValue = newValue;
      }
    },
    mixins: [tableBase],
    methods: {
      openDialog(){
        this.visible = true;
      },
      handleClick(tab){
        if(tab.name==3){
          this.width='60%';
          this.initClassify();
        }else if(tab.name==4){
           this.width='60%';
         }else{
           this.width='40%';
         }
      },
      initClassify(){
        if(this.optionList.length==0){
          this.simplePost("/api/business/goodsClassify/getAll",null,result=>{
            this.optionList.pushAll(result.data);
            this.classify = this.optionList[0];
          });
        }
      },
      selectClassify(tab){
        this.classify={label:tab.label,value:tab.name};
        this.classify2 = {};
        this.classify3 = {};
      },
      selectClassifyItem(val){
        this.classify2 =val;
        this.classify3 = {};
      },
      selectClassifyItem2(val){
        this.classify3 = val;
      },
      changeGoods(item,goodsType){
        this.goodsType = goodsType;
        this.goodsName = item.name;
        this.goodsId = item.id;
      },
      removeGoods(){
        this.goodsType = "";
        this.goodsName = "";
        this.goodsId = "";
      },
      save(){
        let value = "";
        if(this.activeName==1){
          value = this.diyUrl;
        }else if(this.activeName==2){
          value = "/goods/list?keywords="+this.searchValue;
        }else if(this.activeName==3){
          if(this.classify3.label){
            value = "/index/classify/classifySearch?name="+this.classify2.label+"&id="+this.classify2.value+"&childId="+this.classify3.value;
          }else if(this.classify2.label){
            value = "/index/classify/classifySearch?name="+this.classify.label+"&id="+this.classify.value+"&childId="+this.classify2.value;
          }else{
            value = "/index/classify/classifySearch?name="+this.classify.label+"&id="+this.classify.value
          }
        }else if(this.activeName==4){
          value = "/goods/detail?id="+this.goodsId+"&goodsType="+this.goodsType;
        }
        this.inputValue = value;
        this.$emit('update:modelValue', value);
        this.visible=false;
      }
    },
    mounted() {
      this.inputValue = this.modelValue;
    }
  }
</script>


<style lang="less" scoped>

  .classify_span{
    height:40px;
    line-height: 40px;
    padding: 5px 10px;
    border: 1px solid #F39700;
    border-radius: 6px;
    &.active{
      color: #F39700;
    }
  }
</style>
